import React from 'react';
import { Link } from 'react-router';
import logo from '../../../assets/viasport-logo-se-black.png';

export default class MMSPage extends React.PureComponent {

  render() {
    const { auid } = this.props.params;

    const cintUrl = `https://service.survio.se/service1.svc/registerhit?customerId=23&CampaignId=viasatsport&AdId=viasatsportapp&AUID=${auid}&Type=app&Event=loaded`;

    return (
      <div className="mms-page">
        <div className="main-message centered">
          <h3>Tack för att du använder</h3>
        </div>
        <img src={logo} className="mms-page-logo" />
        <div className="main-message">
          <h3>Vi vill informera dig som använder vår app om att vi använder cookies.</h3>
        </div>

        <div className="secondary-message">
          <p>För att kunna erbjuda er bättre utbud genomför vi kvalitetssäkrade tittarmätningar tillsammans med Mediamätning i Skandinavien MMS AB. Den här appen använder cookies för att mäta tittarkonsumtion.</p>
          <p>Se <Link to="/cookies">vår cookiepolicy</Link> för mer information.</p>
        </div>

        <img src={cintUrl} width="1" height="1" style={{display: 'none'}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/MMS/MMSPage.jsx